import React from "react";
import PropTypes from "prop-types";
import MenuItem from "@material-ui/core/MenuItem";
import ExMenu from "./ExMenu";
import withStyles from "@material-ui/core/styles/withStyles";

const styles = {
    subMenuItem: {
        display: "flex",
        justifyContent: "space-between"
    },
    paper: {
        borderRadius: "0px 4px 4px 4px",
        boxShadow:
            "1.5px -0.5px 1.5px 0px rgba(0,0,0,0.2),1.5px 2.5px 1.5px 0px rgba(0,0,0,0.2),0.5px 1px 1px 0px rgba(0,0,0,0.14),0px 2px 1px -1px rgba(0,0,0,0.12)"
    }
};

@withStyles(styles)
class SubMenu extends React.Component {

    static propTypes = {
        caption: PropTypes.string.isRequired,
        classes: PropTypes.any,
        menuItems: PropTypes.array.isRequired,
        selection: PropTypes.bool
    };

    constructor(props) {
        super(props);
        this.handleItemClick = this.handleItemClick.bind(this);
        this.handleSubMenuClose = this.handleSubMenuClose.bind(this);

        this.state = {
            menuOpen: false,
            anchorElement: null
        };
    }

    handleItemClick = event => {
        if (!this.state.anchorElement) {
            this.setState({
                anchorElement: event.currentTarget
            });
        }

        this.setState({
            menuOpen: !this.menuOpen
        });
    };

    handleSubMenuClose = () => {
        this.setState({
            menuOpen: false,
            anchorElement: null
        });
        this.props.closeCallback();
    };

    render() {
        const {caption, menuItems, selection, classes} = this.props;
        const {anchorElement, menuOpen} = this.state;
        return (
            <React.Fragment>
                <MenuItem
                    onClick={this.handleItemClick}
                    className={classes.subMenuItem}
                >
                    {caption}
                </MenuItem>
                <ExMenu
                    classes={{
                        paper: classes.paper
                    }}
                    elevation={1}
                    open={menuOpen}
                    menuItems={menuItems}
                    anchorElement={anchorElement}
                    selection={selection}
                    onClose={this.handleSubMenuClose}
                    anchorOrigin={{vertical: "top", horizontal: "right"}}
                    anchorPosition={{top: 0, left: 500}}
                    transformOrigin={{vertical: "top", horizontal: "left"}}
                />
            </React.Fragment>
        );
    }
}

export default SubMenu;
